import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, Form, message, Flex, Spin } from "antd";
import { useParams } from "react-router-dom";
import { useStripe, useElements, CardNumberElement } from "@stripe/react-stripe-js";

import EmbeddedBookingLayout from "../EmbeddedBookingLayout";
import BookingDetailCard from "./BookingDetailCard";
import ExperienceDetailBlock from "./ExperienceDetailBlock";
import { Icon } from "ui/Icon";
import ContactInformationBlock from "./ContactInformationBlock";
import { fetchExperienceById } from "store/experiences";
import PaymentBlock from "./PaymentBlock";
import styles from "./ExperienceBooking.module.css"

const { Text } = Typography;

const EmbeddedExperienceBooking = () => {
    const dispatch = useDispatch()
    const { id } = useParams()
    const { loading, experienceDetail } = useSelector((state) => state?.experiences?.experienceById)
    const [activeTab, setActiveTab] = useState(1);
    const [bookingErrors, setBookingErrors] = useState({
        date: false,
        counts: false,
        tripLength: false,
        timeSlot: false,
    });
    const [phoneNumber, setPhoneNumber] = useState()
    const [form] = Form.useForm();
    const stripe = useStripe();
    const elements = useElements();

    useEffect(() => {
        if (id) {
            dispatch(fetchExperienceById(id))
        }
    }, [id, dispatch])

    const handleNext = async () => {
        if (activeTab === 1) {
            const stored = localStorage.getItem("bookingSelections");
            let parsed = {};

            try {
                parsed = JSON.parse(stored) || {};
            } catch (e) {
                message.error("Invalid booking data.");
                console.log(e)
                return;
            }

            const { date, counts, tripLength, timeSlot } = parsed;

            const errors = {
                date: !date,
                counts: !counts || Object.values(counts).every((v) => Number(v) <= 0),
                tripLength: !tripLength,
                timeSlot: !timeSlot,
            };

            const hasErrors = Object.values(errors).some(Boolean);

            if (hasErrors) {
                setBookingErrors(errors);
                message.error("Please complete all booking selections before proceeding.");
                return;
            }
            setBookingErrors({ date: false, guests: false, tripLength: false, timeSlot: false });
            setActiveTab((prev) => prev + 1);
        }
        if (activeTab === 2) {
            try {
                await form.validateFields();
                setActiveTab((prev) => prev + 1);
            } catch (error) {
                console.error("Vadiation error", error)
                message.error("Please fill the required data!")
            }
        }
        if (activeTab === 3) {
            try {
                await form.validateFields();
                const cardElement = elements.getElement(CardNumberElement);
                const result = await stripe.confirmCardPayment("pi_3Rbbz9F9IAiyFPvD2Z2IcO6S_secret_YYO4qxPrWo9StoK7DnDTHzcfO", {
                    payment_method: {
                        card: cardElement,
                        billing_details: {
                            name: form.getFieldValue("cardName"),
                            email: form.getFieldValue("email"),
                        },
                    },
                });
                if (result.error) {
                    console.log("result", result)

                    message.error(result.error.message);
                    console.error(result.error);
                } else if (result.paymentIntent.status === "succeeded") {
                    message.success("Payment successful!");
                }
            } catch (error) {
                console.error("Vadiation error", error)
                console.log(form.getFieldsValue())
                message.error("Please fill the required data!")
            }
        }
    };

    return (
        <>
            {loading && (
                <div className={styles.loaderOverlay}>
                    <Spin size="large" />
                </div>
            )}
            <EmbeddedBookingLayout setActiveTab={setActiveTab} activeTab={activeTab} onNext={handleNext}>
                <Flex align="center" justify="space-between" className={`${styles.customTabs}  overflow-hidden`}>
                    {[
                        { label: "CONFIRM BOOKING DETAILS", number: 1 },
                        { label: "CONTACT INFORMATION", number: 2 },
                        { label: "PAYMENT", number: 3 },
                    ].map((item) => (
                        <Flex gap={8} align="center" key={item.number} className={`${activeTab === item.number ? styles.activeTab : ""} py-xxs pl-l pr-xxs flex-1 ${styles.tabItem}`}>
                            <Flex justify="center" align="center" className={`rounded-full ${styles.tabNumber}`}>
                                {item.number < activeTab ? <Icon type="feather" name="Check" /> : item.number}
                            </Flex>
                            <Text className={styles.tabLabel}>
                                {item.label}
                            </Text>
                        </Flex>
                    ))}
                </Flex>
                <Flex gap={40} className={`mt-xl ${styles.detailCardWrapper}`}>
                    <div className="flex-1">
                        <Form
                            layout="vertical"
                            form={form}
                        >
                            {activeTab === 1 && <ExperienceDetailBlock trip={experienceDetail} />}
                            {activeTab === 2 && (
                                <ContactInformationBlock form={form} setPhoneNumber={setPhoneNumber} phoneNumber={phoneNumber} />
                            )}
                            {activeTab === 3 &&
                                <PaymentBlock form={form} />
                            }
                        </Form>
                    </div>
                    <div className="flex-1">
                        <BookingDetailCard bookNow={true} bookingButtonVisible={false} trip={experienceDetail} activeTab={activeTab} bookingErrors={bookingErrors} setBookingErrors={setBookingErrors}
                        />
                    </div>
                </Flex>
            </EmbeddedBookingLayout>
        </>
    );
};

export default EmbeddedExperienceBooking;
